import BaseHttpService from "../baseService";

class UserServiceProvider extends BaseHttpService {
	constructor() {
		super("account");
	}

	/**
	 * Resend activation code
	 *
	 * @param mobile The user national id
	 * @async
	 * @version 1.0.0
	 */
	public sendActivationCode(mobile: string): HttpService.BaseResponse {
		return this.getResource().post(`code/generate/${mobile}`);
	}

	/**
	 * Get current user information object
	 *
	 * @async
	 * @version 1.0.0
	 */
	public getUser(): HttpService.BaseResponse<Account.Profile> {
		return this.getResource().get("my-load");
	}

	/**
	 * Get dashboard information object
	 *
	 * @async
	 * @version 1.0.0
	 */
	public dashboard(): HttpService.BaseResponse<Account.Dashboard> {
		return this.getResource().get("dashboard");
	}

	/**
	 * My update
	 *
	 * @param data
	 * @async
	 * @version 1.0.0
	 */
	public myUpdate(data: Account.ProfileDetail): HttpService.BaseResponse {
		return this.getResource().post("my-update", data);
	}

	/**
	 * Change user password
	 *
	 * @param newPassword User's new password which want to replace with.
	 * @async
	 * @version 1.0.0
	 */
	public changePassword(data: Account.ChangePassword): HttpService.BaseResponse {
		return this.getResource().post("change-my-password", data);
	}

	/**
	 * Change user password
	 *
	 * @async
	 * @version 1.0.0
	 * @param data
	 */
	public forgetPassword(data: Account.ForgetPassword): HttpService.BaseResponse {
		return this.getResource().post("pwd/forget", data);
	}

	public myCredit(): HttpService.BaseResponse<Stock.CreditModel> {
		return this.dynamicMakeResource("financials").get("/my-credit");
	}
}

const UserService = new UserServiceProvider();

export default UserService;
